import React, { useId } from 'react';
import PropTypes, { InferProps } from 'prop-types';

function PressReleaseCard({
  publishMonth,
  publishDay,
  publishYear,
  title,
  url,
  teaser
}: InferProps<typeof PressReleaseCard.propTypes>) {
  const id = useId();

  return (
    <article className="press-release-card" aria-labelledby={id}>
      <div className="press-release-card__date">
        <span className="press-release-card__month">{publishMonth}</span>
        <span className="press-release-card__day">{publishDay}</span>
        <span className="press-release-card__year">{publishYear}</span>
      </div>
      <div className="press-release-card__content">
        <h3 id={id} className="press-release-card__title">
          <a href={url} className="link--inline">
            <span>{title}</span>
          </a>
        </h3>
        <div
          className="press-release-card__teaser rtf--inline"
          dangerouslySetInnerHTML={{ __html: teaser }}
        />
      </div>
    </article>
  );
}

PressReleaseCard.propTypes = {
  publishMonth: PropTypes.string.isRequired,
  publishDay: PropTypes.string.isRequired,
  publishYear: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  teaser: PropTypes.string.isRequired
};

export default PressReleaseCard;
